'use strict';

import defaultTemplate from '../../core/default.html';
import locationsListTemplate from './locations.list.html';
import locationsNewTemplate from './locations.new.html';

import Locations from './locations.ctrl';

function LocationsRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.locations', {
      url: '/locations',
      template: defaultTemplate
    })
    .state('main.locations.list', {
      url: '/list',
      template: locationsListTemplate,
      controller: 'LocationsListController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canIViewLocationList()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.locations.list');
        }
      }
    })
    .state('main.locations.new', {
      url: '/new?:parentId&:from&:fromTab',
      template: locationsNewTemplate,
      controller: 'LocationsNewController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canICreateLocation()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.locations.new');
        }
      }
    });
}

export default angular
  .module('locations.router', [
    Locations
  ])
  .config(LocationsRouter)
  .name;
